















































import { editFactory } from '@/main/pages';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { Zakazka } from '@/modules/servis/zakazka/';

import { NAME } from './constants';
import { store } from './store/edit';
import { types } from './store/types';

export default editFactory(NAME, store).extend({
	components: {
		PracovnikSelect: Pracovnik.components.Select,
		ZakazkaSelect: Zakazka.components.Select,
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				pracovnik: `${this.storeUri}/${types.mutations.PRACOVNIK_SELECT_MAPPER}`,
				zakazka: `${this.storeUri}/${types.mutations.ZAKAZKA_SELECT_MAPPER}`,
			};
		},
		zakzkaFilter() {
			return { ZakazkaNr: this.ZakazkaNr };
		},
		caswPznText() {
			return this.dropdownList.CaswId.find((item) => item.Value === this.CaswId)?.CaswPznText;
		},
	},
	methods: {
		loadedData() {
			if (this.isCreateMode) {
				this.ZacatekDat = new Date();
			}
		},
	},
});
